import base from './base';

const primaryColor = '#0090d2';
const primary = '#0090d2';
const hover = '#ffc800';
const errorColor = '#d71f28';

const hum3 = base({primaryColor, primary, hover, errorColor, base});
hum3.button.backgroundColor = '#f78e1e';
hum3.dateDropdown.padding = '15.6px 30px 12.4px 10px';

export default hum3;
